import _merge from "ramda/es/merge";
import lambdaResponse from './lambdaResponse';

var addCorsHeaders = _merge({
  'Access-Control-Allow-Origin': '*'
});

var lambdaCorsResponse = function (statusCode, body, resHeaders, reqHeaders) {
  return lambdaResponse(statusCode, body, addCorsHeaders(resHeaders), reqHeaders);
};

export default lambdaCorsResponse;